export function formatCurrency(amount: number, currency = 'AUD', locale = 'en-AU'): string {
  return new Intl.NumberFormat(locale, { style: 'currency', currency, minimumFractionDigits: 2 }).format(amount);
}
